export const Contries = [
    {
        id: 1,
        label: 'Afghanistan',
    },
    {
        id: 2,
        label: 'Albania',
    },
    {
        id: 3,
        label: 'Algeria',
    },
    {
        id: 4,
        label: 'Andorra',
    },
    {
        id: 5,
        label: 'Angola',
    },
    {
        id: 6,
        label: 'Antigua and Barbuda',
    },
    {
        id: 7,
        label: 'Argentina',
    },
    {
        id: 8,
        label: 'Armenia',
    },
    {
        id: 9,
        label: 'Australia',
    },
    {
        id: 10,
        label: 'Austria',
    },
    {
        id: 11,
        label: 'Azerbaijan',
    },
    {
        id: 12,
        label: 'Bahamas',
    },
    {
        id: 13,
        label: 'Bahrain',
    },
    {
        id: 14,
        label: 'Bangladesh',
    },
    {
        id: 15,
        label: 'Barbados',
    },
    {
        id: 16,
        label: 'Belarus',
    },
    {
        id: 17,
        label: 'Belgium',
    },
    {
        id: 18,
        label: 'Belize',
    },
    {
        id: 19,
        label: 'Benin',
    },
    {
        id: 20,
        label: 'Bhutan',
    },
    {
        id: 21,
        label: 'Bolivia (Plurinational State of)',
    },
    {
        id: 22,
        label: 'Bosnia and Herzegovina',
    },
    {
        id: 23,
        label: 'Botswana',
    },
    {
        id: 24,
        label: 'Brazil',
    },
    {
        id: 25,
        label: 'Brunei Darussalam',
    },
    {
        id: 26,
        label: 'Bulgaria',
    },
    {
        id: 27,
        label: 'Burkina Faso',
    },
    {
        id: 28,
        label: 'Burundi',
    },
    {
        id: 29,
        label: 'Cabo Verde',
    },
    {
        id: 30,
        label: 'Cambodia',
    },
    {
        id: 31,
        label: 'Cameroon',
    },
    {
        id: 32,
        label: 'Canada',
    },
    {
        id: 33,
        label: 'Central African Republic',
    },
    {
        id: 34,
        label: 'Chad',
    },
    {
        id: 35,
        label: 'Chile',
    },
    {
        id: 36,
        label: 'China',
    },
    {
        id: 37,
        label: 'Colombia',
    },
    {
        id: 38,
        label: 'Comoros',
    },
    {
        id: 39,
        label: 'Congo',
    },
    {
        id: 40,
        label: 'Congo, Democratic Republic of the',
    },
    {
        id: 41,
        label: 'Costa Rica',
    },
    {
        id: 42,
        label: "Côte d'Ivoire",
    },
    {
        id: 43,
        label: 'Croatia',
    },
    {
        id: 44,
        label: 'Cuba',
    },
    {
        id: 45,
        label: 'Cyprus',
    },
    {
        id: 46,
        label: 'Czechia',
    },
    {
        id: 47,
        label: 'Denmark',
    },
    {
        id: 48,
        label: 'Djibouti',
    },
    {
        id: 49,
        label: 'Dominica',
    },
    {
        id: 50,
        label: 'Dominican Republic',
    },
    {
        id: 51,
        label: 'Ecuador',
    },
    {
        id: 52,
        label: 'Egypt',
    },
    {
        id: 53,
        label: 'El Salvador',
    },
    {
        id: 54,
        label: 'Equatorial Guinea',
    },
    {
        id: 55,
        label: 'Eritrea',
    },
    {
        id: 56,
        label: 'Estonia',
    },
    {
        id: 57,
        label: 'Eswatini',
    },
    {
        id: 58,
        label: 'Ethiopia',
    },
    {
        id: 59,
        label: 'Fiji',
    },
    {
        id: 60,
        label: 'Finland',
    },
    {
        id: 61,
        label: 'France',
    },
    {
        id: 62,
        label: 'Gabon',
    },
    {
        id: 63,
        label: 'Gambia',
    },
    {
        id: 64,
        label: 'Georgia',
    },
    {
        id: 65,
        label: 'Germany',
    },
    {
        id: 66,
        label: 'Ghana',
    },
    {
        id: 67,
        label: 'Greece',
    },
    {
        id: 68,
        label: 'Grenada',
    },
    {
        id: 69,
        label: 'Guatemala',
    },
    {
        id: 70,
        label: 'Guinea',
    },
    {
        id: 71,
        label: 'Guinea-Bissau',
    },
    {
        id: 72,
        label: 'Guyana',
    },
    {
        id: 73,
        label: 'Haiti',
    },
    {
        id: 74,
        label: 'Honduras',
    },
    {
        id: 75,
        label: 'Hungary',
    },
    {
        id: 76,
        label: 'Iceland',
    },
    {
        id: 77,
        label: 'India',
    },
    {
        id: 78,
        label: 'Indonesia',
    },
    {
        id: 79,
        label: 'Iran',
    },
    {
        id: 80,
        label: 'Iraq',
    },
    {
        id: 81,
        label: 'Ireland',
    },
    {
        id: 82,
        label: 'Italy',
    },
    {
        id: 83,
        label: 'Jamaica',
    },
    {
        id: 84,
        label: 'Japan',
    },
    {
        id: 85,
        label: 'Jordan',
    },
    {
        id: 86,
        label: 'Kazakhstan',
    },
    {
        id: 87,
        label: 'Kenya',
    },
    {
        id: 88,
        label: 'Kiribati',
    },
    {
        id: 89,
        label: "Korea (Democratic People's Republic of)",
    },
    {
        id: 90,
        label: 'Korea, Republic of',
    },
    {
        id: 91,
        label: 'Kuwait',
    },
    {
        id: 92,
        label: 'Kyrgyzstan',
    },
    {
        id: 93,
        label: "Lao People's Democratic Republic",
    },
    {
        id: 94,
        label: 'Latvia',
    },
    {
        id: 95,
        label: 'Lebanon',
    },
    {
        id: 96,
        label: 'Lesotho',
    },
    {
        id: 97,
        label: 'Liberia',
    },
    {
        id: 98,
        label: 'Libya',
    },
    {
        id: 99,
        label: 'Liechtenstein',
    },
    {
        id: 100,
        label: 'Lithuania',
    },
    {
        id: 101,
        label: 'Luxembourg',
    },
    {
        id: 102,
        label: 'Madagascar',
    },
    {
        id: 103,
        label: 'Malawi',
    },
    {
        id: 104,
        label: 'Malaysia',
    },
    {
        id: 105,
        label: 'Maldives',
    },
    {
        id: 106,
        label: 'Mali',
    },
    {
        id: 107,
        label: 'Malta',
    },
    {
        id: 108,
        label: 'Marshall Islands',
    },
    {
        id: 109,
        label: 'Mauritania',
    },
    {
        id: 110,
        label: 'Mauritius',
    },
    {
        id: 111,
        label: 'Mexico',
    },
    {
        id: 112,
        label: 'Micronesia (Federated States of)',
    },
    {
        id: 113,
        label: 'Moldova, Republic of',
    },
    {
        id: 114,
        label: 'Monaco',
    },
    {
        id: 115,
        label: 'Mongolia',
    },
    {
        id: 116,
        label: 'Montenegro',
    },
    {
        id: 117,
        label: 'Morocco',
    },
    {
        id: 118,
        label: 'Mozambique',
    },
    {
        id: 119,
        label: 'Myanmar',
    },
    {
        id: 120,
        label: 'Namibia',
    },
    {
        id: 121,
        label: 'Nauru',
    },
    {
        id: 122,
        label: 'Nepal',
    },
    {
        id: 123,
        label: 'Netherlands',
    },
    {
        id: 124,
        label: 'New Zealand',
    },
    {
        id: 125,
        label: 'Nicaragua',
    },
    {
        id: 126,
        label: 'Niger',
    },
    {
        id: 127,
        label: 'Nigeria',
    },
    {
        id: 128,
        label: 'North Macedonia',
    },
    {
        id: 129,
        label: 'Norway',
    },
    {
        id: 130,
        label: 'Oman',
    },
    {
        id: 131,
        label: 'Pakistan',
    },
    {
        id: 132,
        label: 'Palau',
    },
    {
        id: 133,
        label: 'Panama',
    },
    {
        id: 134,
        label: 'Papua New Guinea',
    },
    {
        id: 135,
        label: 'Paraguay',
    },
    {
        id: 136,
        label: 'Peru',
    },
    {
        id: 137,
        label: 'Philippines',
    },
    {
        id: 138,
        label: 'Poland',
    },
    {
        id: 139,
        label: 'Portugal',
    },
    {
        id: 140,
        label: 'Qatar',
    },
    {
        id: 141,
        label: 'Romania',
    },
    {
        id: 142,
        label: 'Russian Federation',
    },
    {
        id: 143,
        label: 'Rwanda',
    },
    {
        id: 144,
        label: 'Saint Kitts and Nevis',
    },
    {
        id: 145,
        label: 'Saint Lucia',
    },
    {
        id: 146,
        label: 'Saint Vincent and the Grenadines',
    },
    {
        id: 147,
        label: 'Samoa',
    },
    {
        id: 148,
        label: 'San Marino',
    },
    {
        id: 149,
        label: 'Sao Tome and Principe',
    },
    {
        id: 150,
        label: 'Saudi Arabia',
    },
    {
        id: 151,
        label: 'Senegal',
    },
    {
        id: 152,
        label: 'Serbia',
    },
    {
        id: 153,
        label: 'Seychelles',
    },
    {
        id: 154,
        label: 'Sierra Leone',
    },
    {
        id: 155,
        label: 'Singapore',
    },
    {
        id: 156,
        label: 'Slovakia',
    },
    {
        id: 157,
        label: 'Slovenia',
    },
    {
        id: 158,
        label: 'Solomon Islands',
    },
    {
        id: 159,
        label: 'Somalia',
    },
    {
        id: 160,
        label: 'South Africa',
    },
    {
        id: 161,
        label: 'South Sudan',
    },
    {
        id: 162,
        label: 'Spain',
    },
    {
        id: 163,
        label: 'Sri Lanka',
    },
    {
        id: 164,
        label: 'Sudan',
    },
    {
        id: 165,
        label: 'Surilabel',
    },
    {
        id: 166,
        label: 'Sweden',
    },
    {
        id: 167,
        label: 'Switzerland',
    },
    {
        id: 168,
        label: 'Syrian Arab Republic',
    },
    {
        id: 169,
        label: 'Tajikistan',
    },
    {
        id: 170,
        label: 'Tanzania, United Republic of',
    },
    {
        id: 171,
        label: 'Thailand',
    },
    {
        id: 172,
        label: 'Timor-Leste',
    },
    {
        id: 173,
        label: 'Togo',
    },
    {
        id: 174,
        label: 'Tonga',
    },
    {
        id: 175,
        label: 'Trinidad and Tobago',
    },
    {
        id: 176,
        label: 'Tunisia',
    },
    {
        id: 177,
        label: 'Turkey',
    },
    {
        id: 178,
        label: 'Turkmenistan',
    },
    {
        id: 179,
        label: 'Tuvalu',
    },
    {
        id: 180,
        label: 'Uganda',
    },
    {
        id: 181,
        label: 'Ukraine',
    },
    {
        id: 182,
        label: 'United Arab Emirates',
    },
    {
        id: 183,
        label: 'United Kingdom',
    },
    {
        id: 184,
        label: 'United States of America',
    },
    {
        id: 185,
        label: 'Uruguay',
    },
    {
        id: 186,
        label: 'Uzbekistan',
    },
    {
        id: 187,
        label: 'Vanuatu',
    },
    {
        id: 188,
        label: 'Venezuela (Bolivarian Republic of)',
    },
    {
        id: 189,
        label: 'Viet Nam',
    },
    {
        id: 190,
        label: 'Yemen',
    },
    {
        id: 191,
        label: 'Zambia',
    },
    {
        id: 192,
        label: 'Zimbabwe',
    },
];
